import { render, staticRenderFns } from "./RecordOneComparison.vue?vue&type=template&id=08b1d51a&scoped=true&lang=pug"
import script from "./RecordOneComparison.vue?vue&type=script&lang=js"
export * from "./RecordOneComparison.vue?vue&type=script&lang=js"
import style0 from "./RecordOneComparison.vue?vue&type=style&index=0&id=08b1d51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1d51a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardSubtitle,VCardText,VCol,VIcon,VRow})
